"use client";

import { useRouter, usePathname, useSearchParams } from "next/navigation";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const SORT_OPTIONS = [
  { value: "newest", label: "Varsayılan" },
  { value: "price-asc", label: "Fiyat: Düşükten Yükseğe" },
  { value: "price-desc", label: "Fiyat: Yüksekten Düşüğe" },
  { value: "name-asc", label: "İsim: A-Z" },
  { value: "name-desc", label: "İsim: Z-A" },
];

export function ProductSort() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const current = searchParams.get("sort") ?? "newest";

  const handleChange = (value: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("sort", value);
    params.delete("page");
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2 sm:flex-none">
      <span className="hidden text-sm font-medium text-[var(--es-text-muted)] sm:inline whitespace-nowrap">Sırala</span>
      <Select value={current} onValueChange={handleChange}>
        <SelectTrigger className="h-11 w-full rounded-full border-[var(--sf-accent)]/45 bg-[var(--sf-accent-light)]/70 px-4 text-sm font-semibold shadow-none focus:ring-0 focus-visible:ring-0 dark:border-white/12 dark:bg-white/[0.07] sm:w-[260px]">
          <SelectValue placeholder="Sırala" />
        </SelectTrigger>
        <SelectContent>
          {SORT_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
